import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sigecom-color-picker',
  template: `
    <div class="w-28 h-full rounded-l-lg relative p-2">
      <div
        class="h-full rounded-xl border border-solid flex items-center justify-center"
        [style.background-color]="color"
        [style.border-color]="isLightColor(color) ? '#000' : '#fff'">

        <fa-icon 
          [icon]="icon" 
          [ngClass]="isLightColor(color) ? 'text-black' : 'text-white'"
          class="text-xl pointer-events-none" />

        <input 
          type="color" 
          class="absolute inset-0 opacity-0 cursor-pointer w-full h-full"
          [(ngModel)]="color"
          (change)="colorChange.emit(color)">
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      height: 100%;
    }
  `]
})
export class ColorPickerComponent {
  @Input() color: string = '#000000';
  @Input() icon: any = 'eye-dropper';
  @Output() colorChange = new EventEmitter<string>();

  isLightColor(color: string): boolean {
    if (!color || !color.startsWith('#')) return false;
    const c = color.substring(1);
    const rgb = parseInt(c, 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = rgb & 0xff;
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance > 186;
  }
}
